<template>
  <svg
    width="16"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 20.92"
    class="d-flex"
  >
    <path
      d="m11.37501,6.375l0,10l-8,0l0,-10l8,0m-1.5,-6l-5,0l-1,1l-3.5,0l0,2l14,0l0,-2l-3.5,0l-1,-1zm3.5,4l-12,0l0,12c0,1.1 0.9,2 2,2l8,0c1.1,0 2,-0.9 2,-2l0,-12z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TrashIcon',
};
</script>
